import React from "react";
import { BlueOpenIcon, RedRetryIcon, SuccessIcon } from "Assets";

export const statusIconsWorkOrderDND = [
  <BlueOpenIcon key={"blueOpenIconWorkOrderDND"} />,
  <RedRetryIcon key={"redRetryIconWorkOrderDND"} />,
  <SuccessIcon key={"successIconWorkOrderDND"} />,
];
